import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import SettingsSuggestOutlined from '@mui/icons-material/SettingsSuggestOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
export type ActionRunStepEmptyStateVariant = 'default' | 'error';
interface ActionRunStepEmptyStateProps {
  variant?: ActionRunStepEmptyStateVariant;
}
export default function ActionRunStepEmptyState({
  variant = 'default',
}: ActionRunStepEmptyStateProps) {
  const theme = useTheme();
  const variantConfig = {
    default: {
      Icon: SettingsSuggestOutlined,
      iconColor: theme.palette.semantic.icon.primary,
      textColor: theme.palette.semantic.text.title2,
      content: (
        <>
          There aren’t any actions listed yet. <br /> Please select actions on
          the Actions List
        </>
      ),
    },
    error: {
      Icon: WarningAmberOutlined,
      iconColor: theme.palette.semantic.icon.error,
      textColor: theme.palette.semantic.text.error2,
      content: 'Please add at least one action.',
    },
  };

  const { Icon, iconColor, textColor, content } = variantConfig[variant];
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: theme.palette.semantic.surface.bg1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Icon sx={{ fontSize: 40, color: iconColor }} />
        </Box>
        <Typography sx={{ fontSize: 14, lineHeight: 1.5, color: textColor }}>
          {content}
        </Typography>
      </Box>
    </Box>
  );
}
